import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  LESSON,
  LESSON_ALL,
  LESSON_ASSESSMENT,
  LESSON_ASSESSMENT_ALL,
  LESSON_ASSESSMENT_LIST,
  LESSON_ATTENDANCE,
  LESSON_ATTENDANCE_GROUP,
  LESSON_CREATE,
  LESSON_DELETE,
  LESSON_DISTANCE_LEARNING_ALL,
  LESSON_DISTANCE_LEARNING_CREATE,
  LESSON_DOWNLOAD_FILES,
  LESSON_HOMEWORK_UPLOAD,
  LESSON_LIST,
  LESSON_MARK_ASSESSMENT,
  LESSON_SORTING,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const lesson = createAsyncThunk(
  LESSON,
  async (params: PayloadCreatorParams<`${typeof API.LESSON}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.lesson(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const lessonAll = createAsyncThunk(
  LESSON_ALL,
  async (params: PayloadCreatorParams<`${typeof API.LESSON_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.lessonAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const lessonAssessment = createAsyncThunk(
  LESSON_ASSESSMENT,
  async (params: PayloadCreatorParams<`${typeof API.LESSON_ASSESSMENT}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.lessonAssessment(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const lessonAssessmentAll = createAsyncThunk(
  LESSON_ASSESSMENT_ALL,
  async (params: PayloadCreatorParams<`${typeof API.LESSON_ASSESSMENT_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.lessonAssessmentAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const lessonAssessmentList = createAsyncThunk(
  LESSON_ASSESSMENT_LIST,
  async (params: PayloadCreatorParams<`${typeof API.LESSON_ASSESSMENT}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.lessonAssessmentList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const lessonCreate = createAsyncThunk(
  LESSON_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.LESSON}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.lessonCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const disLearningLessonCreate = createAsyncThunk(
  LESSON_DISTANCE_LEARNING_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.LESSON_DISTANCE_LEARNING}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.disLearningLessonCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const disLearningLessonAll = createAsyncThunk(
  LESSON_DISTANCE_LEARNING_ALL,
  async (params: PayloadCreatorParams<`${typeof API.LESSON_DISTANCE_LEARNING_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.disLearningLessonAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const lessonDelete = createAsyncThunk(
  LESSON_DELETE,
  async (params: PayloadCreatorParams<`${typeof API.LESSON}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.lessonDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const lessonHomeworkUpload = createAsyncThunk(
  LESSON_HOMEWORK_UPLOAD,
  async (params: PayloadCreatorParams<`${typeof API.LESSON_HOMEWORK_UPLOAD}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.lessonHomeworkUpload(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const lessonList = createAsyncThunk(
  LESSON_LIST,
  async (params: PayloadCreatorParams<`${typeof API.LESSON}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.lessonList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const lessonMarkAssessment = createAsyncThunk(
  LESSON_MARK_ASSESSMENT,
  async (params: PayloadCreatorParams<`${typeof API.LESSON_ASSESSMENT}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.lessonMarkAssessment(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const lessonSorting = createAsyncThunk(
  LESSON_SORTING,
  async (params: PayloadCreatorParams<`${typeof API.LESSON_SORTING}`, 'put'>, { rejectWithValue }) => {
    try {
      const response = await api.lessonSorting(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const lessonDownloadFiles = createAsyncThunk(
  LESSON_DOWNLOAD_FILES,
  async (params: PayloadCreatorParams<`${typeof API.LESSON_DOWNLOAD_FILES}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.lessonDownloadFiles(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const lessonAttendance = createAsyncThunk(
  LESSON_ATTENDANCE,
  async (params: PayloadCreatorParams<`${typeof API.LESSON_ATTENDANCE}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.lessonAttendance(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const lessonAttendanceGroup = createAsyncThunk(
  LESSON_ATTENDANCE_GROUP,
  async (params: PayloadCreatorParams<`${typeof API.LESSON_ATTENDANCE_GROUP}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.lessonAttendanceGroup(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const lessonClear = createAction(`${LESSON}/clear`)

export const lessonListClear = createAction(`${LESSON_LIST}/clear`)

export const lessonAllClear = createAction(`${LESSON_ALL}/clear`)

export const lessonHomeworkUploadClear = createAction(`${LESSON_HOMEWORK_UPLOAD}/clear`)

export const lessonAssessmentClear = createAction(`${LESSON_ASSESSMENT}/clear`)

export const lessonAssessmentAllClear = createAction(`${LESSON_ASSESSMENT_ALL}/clear`)

export const lessonAssessmentListClear = createAction(`${LESSON_ASSESSMENT_LIST}/clear`)

export const lessonDownloadFilesClear = createAction(`${LESSON_DOWNLOAD_FILES}/clear`)

export const disLearningLessonAllClear = createAction(`${LESSON_DISTANCE_LEARNING_ALL}/clear`)

export const lessonAttendanceClear = createAction(`${LESSON_ATTENDANCE}/clear`)
export const lessonAttendanceGroupClear = createAction(`${LESSON_ATTENDANCE_GROUP}/clear`)
